const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Size',
        dataIndex: 'size',
        render: defaultRender,
    },
    {
        title: 'Date Added',
        dataIndex: 'dateAdded',
        render: defaultRender,
    },
    {
        title: '',
        dataIndex: 'actions',
        render: defaultRender,
    },
];

export default columns;